import {
    AddressDTO,
    BankDetailsDTO,
    CompanyDTO,
    CompanyReportingDataMappingDTO,
    CompanyVendorIdDTO,
    NoteDTO,
    PlatformLicenseActivationDTO
} from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { AttributeListResult } from 'src/app/shared/components/attribute-list/attribute-list.component';
import { CompanyDTO as INHCoreCompanyDTO, CompanyReportingDataView } from '@iota/inh-core-v1-management-client';

export enum CompanyActionTypes {
    LoadCompanies = '[Company] LoadCompanies',
    LoadCompaniesSuccess = '[Company] LoadCompaniesSuccess',
    LoadCompaniesFailure = '[Company] LoadCompaniesFailure',

    LoadCompany = '[Company] LoadCompany',
    LoadCompanySuccess = '[Company] LoadCompanySuccess',
    LoadCompanyFailure = '[Company] LoadCompanyFailure',

    CompanyActionFailure = '[Company] CompanyActionFailure',

    UpsertCompany = '[Company] UpsertCompany',
    UpsertCompanySuccess = '[Company] UpsertCompanySuccess',
    UpsertCompanyFailure = '[Company] UpsertCompanyFailure',

    AddUpdateRemoveCompanyAttributes = '[Company] AddUpdateRemoveCompanyAttributes',

    UpsertCompanyNote = '[Company] UpsertCompanyNote',
    RemoveCompanyNote = '[Company] RemoveCompanyNote',

    UpsertCompanyAddress = '[Company] UpsertCompanyAddress',
    RemoveCompanyAddress = '[Company] RemoveCompanyAddress',

    UpsertCompanyBankDetails = '[Company] UpsertCompanyBankDetails',
    RemoveCompanyBankDetails = '[Company] RemoveCompanyBankDetails',

    UpsertCompanyAttachment = '[Company] UpsertCompanyAttachment',
    RemoveCompanyAttachment = '[Company] RemoveCompanyAttachment',

    UpsertCompanyVendorId = '[Company] UpsertCompanyVendorId',
    RemoveCompanyVendorId = '[Company] RemoveCompanyVendorId',

    LoadReportingDataMapping = '[ReportingDataMapping] Load Reporting Data Mapping',
    LoadReportingDataMappingSuccess = '[ReportingDataMapping] Load Reporting Data Mapping Success',
    LoadReportingDataMappingFailure = '[ReportingDataMapping] Load Reporting Data Mapping Failure',

    UpsertReportingDataMapping = '[ReportingDataMapping] Upsert Reporting Data Mapping',
    UpsertReportingDataMappingSuccess = '[ReportingDataMapping] Upsert Reporting Data Mapping Success',
    UpsertReportingDataMappingFailure = '[ReportingDataMapping] Upsert Reporting Data Mapping Failure',

    LoadCompanyReportingDataWithMapping = '[Company] Load Company Reporting Data With Mapping',
    LoadCompanyReportingDataWithMappingSuccess = '[Company] Load Company Reporting Data With Mapping Success',
    LoadCompanyReportingDataWithMappingFailure = '[Company] Load Company Reporting Data With Mapping Failure'
}

export const CompanyActionFailure = createAction(CompanyActionTypes.CompanyActionFailure, props<{ error: any }>());

export const UpsertCompanyBankDetails = createAction(
    CompanyActionTypes.UpsertCompanyBankDetails,
    props<{
        bankDetails: BankDetailsDTO;
    }>()
);
export const RemoveCompanyBankDetails = createAction(
    CompanyActionTypes.RemoveCompanyBankDetails,
    props<{
        bankDetailsId: string;
    }>()
);
export const UpsertCompanyAddress = createAction(
    CompanyActionTypes.UpsertCompanyAddress,
    props<{
        address: AddressDTO;
    }>()
);
export const RemoveCompanyAddress = createAction(
    CompanyActionTypes.RemoveCompanyAddress,
    props<{
        addressId: string;
    }>()
);
export const UpsertCompanyNote = createAction(CompanyActionTypes.UpsertCompanyNote, props<{ note: NoteDTO }>());
export const RemoveCompanyNote = createAction(CompanyActionTypes.RemoveCompanyNote, props<{ noteId: string }>());

export const UpsertCompanyAttachment = createAction(
    CompanyActionTypes.UpsertCompanyAttachment,
    props<{ companyId: string; file: File; labels?: string[] }>()
);
export const RemoveCompanyAttachment = createAction(
    CompanyActionTypes.RemoveCompanyAttachment,
    props<{ companyId: string; documentDescriptionId: string }>()
);

export const LoadCompanies = createAction(CompanyActionTypes.LoadCompanies);
export const LoadCompaniesSuccess = createAction(
    CompanyActionTypes.LoadCompaniesSuccess,
    props<{
        companies: INHCoreCompanyDTO[];
    }>()
);
export const LoadCompaniesFailure = createAction(CompanyActionTypes.LoadCompaniesFailure, props<{ error: any }>());

export const LoadCompany = createAction(CompanyActionTypes.LoadCompany, props<{ companyId: string }>());
export const LoadCompanySuccess = createAction(CompanyActionTypes.LoadCompanySuccess, props<{ company: CompanyDTO }>());
export const LoadCompanyFailure = createAction(CompanyActionTypes.LoadCompanyFailure, props<{ error: any }>());

export const UpsertCompany = createAction(CompanyActionTypes.UpsertCompany, props<{ company: CompanyDTO }>());
export const UpsertCompanySuccess = createAction(
    CompanyActionTypes.UpsertCompanySuccess,
    props<{
        company: INHCoreCompanyDTO;
        companyId: string;
    }>()
);
export const UpsertCompanyFailure = createAction(CompanyActionTypes.UpsertCompanyFailure, props<{ error: any }>());

export const AddUpdateRemoveCompanyAttributes = createAction(
    CompanyActionTypes.AddUpdateRemoveCompanyAttributes,
    props<{ attributeResult: AttributeListResult }>()
);

export const UpsertCompanyVendorId = createAction(
    CompanyActionTypes.UpsertCompanyVendorId,
    props<{ companyVendorId: CompanyVendorIdDTO }>()
);
export const RemoveCompanyVendorId = createAction(
    CompanyActionTypes.RemoveCompanyVendorId,
    props<{
        companyVendorIdId: string;
    }>()
);

export const LoadReportingDataMapping = createAction(
    CompanyActionTypes.LoadReportingDataMapping,
    props<{
        companyId: string;
    }>()
);

export const LoadReportingDataMappingSuccess = createAction(
    CompanyActionTypes.LoadReportingDataMappingSuccess,
    props<{ data: CompanyReportingDataMappingDTO }>()
);

export const LoadReportingDataMappingFailure = createAction(
    CompanyActionTypes.LoadReportingDataMappingFailure,
    props<{
        error: any;
    }>()
);

export const UpsertReportingDataMapping = createAction(
    CompanyActionTypes.UpsertReportingDataMapping,
    props<{ companyId: string; dataMapping: CompanyReportingDataMappingDTO }>()
);

export const UpsertReportingDataMappingSuccess = createAction(
    CompanyActionTypes.UpsertReportingDataMappingSuccess,
    props<{ data: CompanyReportingDataMappingDTO }>()
);

export const UpsertReportingDataMappingFailure = createAction(
    CompanyActionTypes.UpsertReportingDataMappingFailure,
    props<{ error: any }>()
);

export const LoadCompanyReportingDataWithMapping = createAction(
    CompanyActionTypes.LoadCompanyReportingDataWithMapping,
    props<{ companyId: string }>()
);

export const LoadCompanyReportingDataWithMappingSuccess = createAction(
    CompanyActionTypes.LoadCompanyReportingDataWithMappingSuccess,
    props<{ data: CompanyReportingDataView }>()
);

export const LoadCompanyReportingDataWithMappingFailure = createAction(
    CompanyActionTypes.LoadCompanyReportingDataWithMappingFailure,
    props<{ error: any }>()
);

export const UpsertCompanyPlatformLicenseActivation = createAction(
    '[Company] UpsertCompanyPlatformLicenseActivation',
    props<{ plaformLicenseActivation: PlatformLicenseActivationDTO }>()
);
export const UpsertCompanyPlatformLicenseActivationFailure = createAction(
    '[Company] UpsertCompanyPlatformLicenseActivationFailure',
    props<{ error: any }>()
);
export const RemovePlatformLicenseActivationFromSelectedCompany = createAction(
    '[Company] RemovePlatformLicenseActivationFromSelectedCompany',
    props<{ platformLicenseActivationId: string }>()
);
export const RemovePlatformLicenseActivationFromSelectedCompanyFailure = createAction(
    '[Company] RemovePlatformLicenseActivationFromSelectedCompanyFailure',
    props<{ error: any }>()
);

export const LoadPlatformLicenseActivationsOfCompanyThatHaveNotBeenInvoiced = createAction(
    '[Company] LoadPlatformLicenseActivationsOfCompanyThatHaveNotBeenInvoiced',
    props<{ companyId: string }>()
);
export const LoadPlatformLicenseActivationsOfCompanyThatHaveNotBeenInvoicedSuccess = createAction(
    '[Company] LoadPlatformLicenseActivationsOfCompanyThatHaveNotBeenInvoicedSuccess',
    props<{ licenseActivationIdsThatHaveNotBeenInvoiced: string[] }>()
);
export const LoadPlatformLicenseActivationsOfCompanyThatHaveNotBeenInvoicedFailure = createAction(
    '[Company] LoadPlatformLicenseActivationsOfCompanyThatHaveNotBeenInvoicedFailure',
    props<{ error: any }>()
);
